const STOP_WORDS = new Set([
  'a', 'an', 'and', 'or', 'the', 'to', 'for', 'of', 'in', 'on', 'with', 'by', 'at', 'from', 'is', 'it',
]);

const clampText = (value, max) => {
  const text = String(value || '').replace(/\s+/g, ' ').trim();
  if (!text) return '';
  if (text.length <= max) return text;
  return `${text.slice(0, max - 1).trim()}...`;
};

export const extractSeoKeywords = (car) => {
  const tokens = [
    car?.year,
    car?.make,
    car?.model,
    car?.trim,
    car?.bodyType,
    car?.fuelType,
    car?.drivetrain,
    'used car',
    'car dealership',
    'buy car online',
  ]
    .map((part) => String(part || '').toLowerCase().trim())
    .filter(Boolean)
    .flatMap((part) => part.split(/\s+/))
    .filter((token) => token && token.length > 2 && !STOP_WORDS.has(token));

  return [...new Set(tokens)].slice(0, 14);
};

export const buildSeoDescription = (car, baseDescription) => {
  const title = `${car?.year || ''} ${car?.make || ''} ${car?.model || ''}`.replace(/\s+/g, ' ').trim();
  const mileage = car?.mileage ? `${Number(car.mileage).toLocaleString()} miles` : null;
  const price = car?.price ? `$${Number(car.price).toLocaleString()}` : null;
  const highlights = [mileage, car?.transmission, car?.fuelType].filter(Boolean).join(' | ');
  const raw = baseDescription || `Shop this ${title} at our dealership with transparent pricing and fast scheduling.`;
  const summary = clampText(raw, 120);
  const composed = [summary, highlights ? `Key specs: ${highlights}.` : '', price ? `Price: ${price}.` : ''].join(' ').trim();
  return clampText(composed, 160);
};

export const buildSeoTitle = (car) => {
  const title = `${car?.year || ''} ${car?.make || ''} ${car?.model || ''}`.replace(/\s+/g, ' ').trim();
  return clampText(`${title} for Sale | BuySell Car Dealership`, 60);
};

export const computeSeoScore = ({ title, description, keywords, hasImages, hasVin, hasPrice }) => {
  let score = 0;
  if (title && title.length >= 30 && title.length <= 60) score += 30;
  if (description && description.length >= 110 && description.length <= 160) score += 30;
  if (Array.isArray(keywords) && keywords.length >= 6) score += 20;
  if (hasImages) score += 10;
  if (hasVin || hasPrice) score += 10;
  return Math.min(100, score);
};

export const trackSeoKeywords = ({ stockNumber, keywords = [] }) => {
  if (typeof window === 'undefined' || !stockNumber || keywords.length === 0) return;
  try {
    const storageKey = 'seoKeywordTracking';
    const raw = localStorage.getItem(storageKey);
    const parsed = raw ? JSON.parse(raw) : {};
    const now = new Date().toISOString();
    const current = parsed[stockNumber] || {};
    keywords.forEach((keyword) => {
      const k = String(keyword || '').toLowerCase().trim();
      if (!k) return;
      const existing = current[k] || { hits: 0, lastSeenAt: null };
      current[k] = { hits: existing.hits + 1, lastSeenAt: now };
    });
    parsed[stockNumber] = current;
    localStorage.setItem(storageKey, JSON.stringify(parsed));
  } catch (_) {
    // Ignore localStorage errors in private mode/restricted environments.
  }
};
